import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {LivelihoodInformation} from '../model/livelihood-information.model';
import {Injectable} from '@angular/core';

@Injectable()
export class LivelihoodInformationService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async create(livelihoodInformation: LivelihoodInformation): Promise<LivelihoodInformation> {
        const url = this.configService.loanApplicationServiceUrl() + '/livelihood-information';
        return await this.httpClient.post<LivelihoodInformation>(url, livelihoodInformation).toPromise();
    }

    public async getByLoanApplicationId(loanApplicationId: String): Promise<LivelihoodInformation> {
        const url = this.configService.loanApplicationServiceUrl() + `/livelihood-information?loanApplicationId=${loanApplicationId}`;
        return await this.httpClient.get<LivelihoodInformation>(url).toPromise();
    }

    public async update(livelihoodInformation: LivelihoodInformation): Promise<LivelihoodInformation> {
        const url = this.configService.loanApplicationServiceUrl() + `/livelihood-information/${livelihoodInformation.id}`;
        return await this.httpClient.put<LivelihoodInformation>(url, livelihoodInformation).toPromise();
    }
}